
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import ReviewBoardPc from './components/ReviewBoardPc';

export default {
  i18nComponentKey: 'WidgetProductReviewsBoard.WidgetProductReviewsBoardPc',
  name: 'WidgetProductReviewsBoardPc',
  components: { ReviewBoardPc },
  mixins: [PaginatedReviewResourceView],
  computed: {
    ...mapState('review', [
      'totalReviewsCount',
      'totalProductMediaReviewsCount'
    ]),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    ...mapGetters('widget', [
      'headerSectionShowable',
      'showFilterSection',
      'appHeaderV2AndTitleShowable'
    ]),
    ...mapGetters('reviewSettings', ['isAuthorDisplayTypeUserGrade']),
    defaultResourceParams() {
      return {
        fields: [
          'has_media',
          'total_reviews_count',
          'total_product_media_reviews_count',
          'reviews.customer_properties',
          'reviews.evaluation_properties',
          this.reviewSettings.always_show_comments ? 'reviews.comments' : '',
          this.isAuthorDisplayTypeUserGrade ? 'reviews.brand_user_grade' : ''
        ]
          .filter(v => v)
          .join(',')
      };
    },
    reviewsContainerStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    }
  },
  created() {
    if (this.widget.show_product_score)
      this.fetchProductScoreSummary({ fields: 'scores_map' });
    if (this.widget.show_title || this.widget.show_product_score)
      this.fetchReviewWritableCheck();

    this.SET_EDIT_OR_DELETE_CALLBACK(() => this.searchResource());
  },
  beforeDestroy() {
    this.SET_EDIT_OR_DELETE_CALLBACK(null);
  },
  methods: {
    ...mapActions('productScoreSummary', ['fetchProductScoreSummary']),
    ...mapActions('review', ['fetchReviewWritableCheck']),
    ...mapMutations('review', ['SET_EDIT_OR_DELETE_CALLBACK']),
    submit(params) {
      this.searchResource(params);
    }
  }
};
